module.exports = __webpack_public_path__ + "static/media/chieraToniolo2.d537e118.jpg";